import { RouteObject } from 'react-router-dom';

import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

import Monitoring from '../Monitoring';
import { RouteDetailPage } from '../pages';

const MonitoringRoutes: RouteObject[] = [
  {
    path: 'monitoring',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.adminOrDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <Monitoring />
      </Authorize>
    ),
  },
  {
    path: 'monitoring/:routeId',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.adminOrDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <RouteDetailPage />
      </Authorize>
    ),
  },
];

export default MonitoringRoutes;
